
































import Vue from "vue"
import SimpleModal from "~/components/guideline/modal/SimpleModal.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import { swUrl } from "~/config/url"

export default Vue.extend({
  components: {
    SimpleModal,
    ConversionButton,
  },
  computed: {
    isShownSwProjectApplyModal(): boolean {
      return this.$clStores.projectApplyMessage.getters
        .isShownSwProjectApplyModal
    },
    privacyPolicyUrl(): string {
      return swUrl.privacyPolicy
    },
  },
  methods: {
    handleApply() {
      this.$emit("apply")
    },
    closeSwProjectApplyModal() {
      this.$clStores.projectApplyMessage.actions.closeSwProjectApplyModal()
    },
  },
})
